import React, { useCallback, useContext } from "react";

import { AlertContext } from "components/AlertProvider/AlertProvider";
import { AuthContext } from "components/AuthProvider/AuthProvider";
import { useSendData, Method } from "hooks/useSendData";

export function useHandleSubmit<I, O>(
	thingToSubmit: string,
	personWhoWillConfirm: string,
	thingThatWillBeConfirmed: string,
	method: Method<I, O>,
	onSent: () => void,
	onFailed: () => void
) {
	const [addAlert] = useContext(AlertContext);
	const [{ uid }] = useContext(AuthContext);

	const doRequest = useSendData({
		method,
		onFailure: e => {
			// Do nothing here
		}
	});

	const handleSubmit = useCallback(
		(data: I) => {
			if (!uid) {
				throw new Error("No requester UID");
			}

			const req = doRequest(data, { uid });

			// TODO:WV:20230501:Fix 'set state on unmounted component' error after submitting this form
			const ready = req.ready.then(() => {
				addAlert({
					contents: (
						<>
							<p>{thingToSubmit} received - thank you.</p>
							<p>
								Please now wait a short while for your {personWhoWillConfirm} to
								confirm the {thingThatWillBeConfirmed}.
							</p>
						</>
					)
				});
				onSent();
			});

			return {
				ready,
				abort: () => req.abort(),
				aborted: () => req.aborted()
			};
		},
		[
			addAlert,
			onSent,
			uid,
			doRequest,
			thingToSubmit,
			personWhoWillConfirm,
			thingThatWillBeConfirmed
		]
	);

	return handleSubmit;
}
